import axios from "axios";
import { TOKEN_ERROR_CODE } from "../constants/commonConstant";

const baseApi = axios.create({
  headers: {
    "Content-type": "application/json",
    Accept: "application/json; charset=utf-8"
  },
  withCredentials: true // JSESSIONID 쿠키 명시적 전달 (NPM 통과 시 안전)
});

// 모든 요청에 token 헤더 자동 첨부.
// 각 api 호출 측에서 headers.token 따로 안 적어도 동작 보장.
baseApi.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.token = token;
  }
  return config;
});

// 세션/토큰 만료 일괄 처리.
// 백엔드 SessionFilter가 인증 실패 시 { result: { retCode: "F00001" } } JSON을 응답하므로,
// 이 응답을 가로채 localStorage 정리 후 로그인 페이지로 이동시킨다.
let redirecting = false;
baseApi.interceptors.response.use(
  res => {
    const retCode = res && res.data && res.data.result && res.data.result.retCode;
    if (retCode === TOKEN_ERROR_CODE) {
      if (!redirecting) {
        redirecting = true;
        try {
          localStorage.removeItem("token");
          localStorage.removeItem("adminYn");
        } catch (e) {
          // localStorage 사용 불가 환경 무시
        }
        window.location.href = "/";
      }
      return Promise.reject({ tokenExpired: true, retCode });
    }

    // Sliding expiration — 백엔드 SessionFilter 가 인증 성공 시 응답 header 'token' 으로
    // 만료 시각이 갱신된 새 토큰을 내려보냄. 받아서 localStorage 갱신 → 다음 요청에 자동 사용.
    // 헤더 키는 대소문자 무시 (axios 가 소문자로 정규화).
    try {
      const refreshed = res && res.headers && (res.headers.token || res.headers.Token);
      if (refreshed && refreshed !== localStorage.getItem("token")) {
        localStorage.setItem("token", refreshed);
      }
    } catch (e) {
      // localStorage 사용 불가 환경 무시
    }
    return res;
  },
  err => Promise.reject(err)
);

export default baseApi;
